import {ElLoading} from "element-plus";
import axios from "axios";

/**
 * 一定要在data里面加上loading,data()=>{return{loading:{}}}
 * 主方法体要return出一个http
 * @param loading
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function LoadingButton(loading) {
    return (target, name, descriptor) => {
        const fn = descriptor.value
        descriptor.value = async function (...rest) {
            if (!this["loading"][loading]) {
                this["loading"][loading] = true
            }
            await fn.call(this, ...rest)
            this["loading"][loading] = false
        }
    }
}

/**
 * 全局Loading动画
 * @param text loading的文本
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Loading(text) {
    return (target, name, descriptor) => {
        const fn = descriptor.value
        descriptor.value = async function (...arg) {
            let r = fn.call(this, ...arg)
            let start = null

            if (r !== false) {
                start = ElLoading.service({
                    lock: true, text: text ? text : "Haier", background: 'rgba(0, 0, 0, 0.7)',
                })
            }
            if (start) {
                await r
                await start.close()

            }
            return r
        }
    }
}

/**
 * 自带取消的请求--不用麻烦自己取消--非常好用
 * @param proxy
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Request(proxy) {
    return (target, name, descriptor) => {
        const f = descriptor.value
        let requestObject = null
        descriptor.value = function (...arg) {
            window.request = (config) => {
                if (requestObject) {
                    requestObject.cancel()
                }
                requestObject = axios.CancelToken.source()
                let url = (proxy ? proxy.startsWith("/") ? proxy : "/" + proxy : "") + (config.url.startsWith("/") ? config.url : "/" + config.url)
                return axios({
                    ...config, url: url, cancelToken: requestObject.token
                }).then((res) => {
                    delete window.request
                    return Promise.resolve(res)
                }, (err) => {
                    delete window.request
                    if (err.toString() !== "Cancel") return Promise.reject(err)
                    return new Promise(() => {})
                })
            }
            return f.call(this, ...arg)
        }
    }
}

/**
 * 导出文件，写个文件名掉方法即可
 * @param fileName
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Export(fileName) {
    return (target, name, descriptor) => {
        const f = descriptor.value
        descriptor.value = function (...arg) {
            return f.call(this, ...arg).then(async res => {
                if (res.status === 200) {
                    try {
                        let blobText = new Blob([res.data], {
                            type: "application/json",
                        }); // 文件流
                        let response = JSON.parse(await blobText.text())
                        if (response.success === false) {
                            this.error(response.msg)
                        }
                    } catch (e) {
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel",
                        }); // 文件流
                        let blobUrl = URL.createObjectURL(blob);
                        const link = document.createElement("a"); //模拟a链接，不支持低版本ie
                        link.download = fileName;
                        link.style.display = "none";
                        link.href = blobUrl;
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                        document.body.removeChild(link);
                    }
                }
            }, err => {
                this.error(err)
            })
        }
    }
}

/**
 * 时间格式化 配合上Element的formatter字段非常好用
 * @param number 要格式化传进来的第几个数据从1开始
 * @param type 要格式化成的模版 yyyy-MM-dd HH:mm:ss
 * @param nullValue 为空默认字符 -
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Time(number, type, nullValue = "-") {
    return (target, name, descriptor) => {
        function time_(dataStr) {
            let date = new Date(dataStr);
            let y = date.getFullYear();

            let m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;

            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;

            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;

            //获得分
            let mm = date.getMinutes()
            mm = mm < 10 ? ('0' + mm) : mm;

            //获得秒
            let ss = date.getSeconds()
            ss = ss < 10 ? ('0' + ss) : ss;
            return [y, m, d, h, mm, ss]
        }

        function type_(time, type = "yyyy-MM-dd HH:mm:ss") {
            let timer = ""
            if (type.includes("yyyy")) {
                timer += time[0]
            }
            if (type.includes("MM")) {
                timer += (timer === "" ? time[1] : "-" + time[1])
            }
            if (type.includes("dd")) {
                timer += (timer === "" ? time[2] : "-" + time[2])
            }
            if (type.includes("HH")) {
                timer += (timer === "" ? time[3] : " " + time[3])
            }
            if (type.includes("mm")) {
                timer += (timer === "" ? time[4] : ":" + time[4])
            }
            if (type.includes("ss")) {
                timer += (timer === "" ? time[5] : ":" + time[5])
            }
            return timer
        }

        const fn = descriptor.value
        descriptor.value = function (...rest) {
            if (!rest[number - 1] || rest[number - 1] === "" || rest[number - 1] === null) {
                return fn.call(this, nullValue, ...rest)
            } else {
                if (new Date(rest[number - 1]).getTime().toString() === "NaN") {
                    console.log("时间格式化错误")
                } else {
                    return fn.call(this, type_(time_(rest[number - 1]), type), ...rest)
                }
            }
        }
    }
}

/**
 * 数据格式化 配合上Element的formatter字段非常好用
 * @param number  要格式化传进来的第几个数据从1开始
 * @param value 要格式化成的模版 {} 在data中定义
 * @param nullValue 为空默认字符 -
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function DataFormatter(number, value, nullValue = "-") {

    return (target, name, descriptor) => {
        const f = descriptor.value

        descriptor.value = function (...arg) {
            if (!["string", "number"].includes(typeof arg[number - 1])) {
                if (!arg[number - 1] || arg[number - 1] === "" || arg[number - 1] === null) {
                    return f.call(this, nullValue, ...arg)
                } else {
                    throw new Error("数据格式化错误")
                }
            } else {
                return f.call(this, this[value][arg[number - 1]], ...arg)
            }
        }
    }
}


/**
 * 按规则去除对象中的数
 * @param list {Array} 匹配规则
 * @returns {(function(*, *, *): void)|*}
 * @constructor
 */
function Trim(list) {
    return (target, name, descriptor) => {
        const f = descriptor.value

        descriptor.value = function (...arg) {
            arg.forEach(v => {
                if (Object.prototype.toString.call(v) === "[object Object]") {

                    for (const vKey in v) {
                        if (list.includes(v[vKey])) {
                            delete v[vKey]
                        }
                    }
                }
            })
            return f.call(this, ...arg)
        }
    }
}

export {
    LoadingButton, Loading, Request, Export, Time, DataFormatter, Trim
}
